function getPropertiesValue(value) {
  if (typeof value === 'string') return value[0] === '$' ? value : `"${value}"`
  if (Array.isArray(value)) return `[${value.map((v) => getPropertiesValue(v)).join(', ')}]`
  return `${value}`
}

export function getPropertiesString(properties) {
  const propertiesString = Object.entries(properties || {})
    .map(([key, value]) => `${key}: ${getPropertiesValue(value)}`)
    .join(', ')
  return propertiesString ? `(${propertiesString})` : ''
}

export function getTransformsString(transforms) {
  return Object.entries(transforms || {})
    .map(([prefix, transform]) => {
      const transformStr = getPropertiesString(transform)
      return `  _${prefix}Url: url${transformStr ? ` @transform${transformStr}` : ''}
  _${prefix}Width: width${transformStr ? ` @transform${transformStr}` : ''}
  _${prefix}Height: height${transformStr ? ` @transform${transformStr}` : ''}`
    })
    .join('\n')
}

/**
 * Create a graphql snippet
 *
 * `createImagesMediaQuery("images", { lg: { width: 1024 }, sm: {width: 512 } })`
 * `createImagesMediaQuery("images", { lg: { width: 1024 }, sm: {width: 512 } }, { limit: 1, orderBy: "title" })`
 */
export function createImagesMediaQuery(handle, transforms, properties = undefined) {
  return `${handle} ${getPropertiesString(properties)} {
  title
${getTransformsString(transforms)}
  ... on animal_Asset { source }
  ... on common_Asset { source }
  ... on quote_Asset { source }
  ... on sponsor_Asset { staticWebPage }
  ... on user_Asset { source }
  ... on writer_Asset { source }
}`
}
